import { render, staticRenderFns } from "./AppWijzigenAdviseur.vue?vue&type=template&id=53fea8ae&scoped=true&"
import script from "./AppWijzigenAdviseur.ts?vue&type=script&lang=ts&"
export * from "./AppWijzigenAdviseur.ts?vue&type=script&lang=ts&"
import style0 from "./AppWijzigenAdviseur.scss?vue&type=style&index=0&id=53fea8ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fea8ae",
  null
  
)

export default component.exports